import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import {
  BEACON_TOPIC_BANNER,
  BEACON_TOPIC_EDIT,
  BEACON_TOPIC_EDIT_MODAL,
  BEACON_TOPIC_MEMBERS,
  BEACON_TOPIC_OVERFLOW_MENU,
  BEACON_TOPIC_SIDEBAR,
  TUTORIAL_NAME_TOPIC,
} from '../../constants/onboarding';
import beginning from '../../images/tutorials/topic/beginning.png';
import customize from '../../images/tutorials/topic/customize.gif';
import end from '../../images/tutorials/topic/end.png';
import members from '../../images/tutorials/topic/members.gif';
import nesting from '../../images/tutorials/topic/nesting.gif';
import personalize from '../../images/tutorials/topic/personalize.gif';
import { TOPIC_SETTING_MENU_TITLE } from '../../topic/constants';
import EditTopicModal from '../../topic/modal/EditTopicModal';
import Tutorial from './Tutorial';

const TopicTutorial = () => {
  const isEditModalShown = useAppSelector(
    (state) => state.ui.modal.isOpen && state.ui.modal.View === EditTopicModal,
  );

  return (
    <Tutorial
      name={TUTORIAL_NAME_TOPIC}
      steps={[
        {
          title: 'Get to know Topics',
          message:
            'Topics keep your posts organized into groups. Each topic can have its own permissions settings and an infinite amount of subtopics.',
          imageUrl: beginning,
        },
        {
          title: 'Membership',
          message:
            'Topic members receive notifications when posts are published or edited. Private topics require membership to view and edit their posts. Open topics allow access to all users.',
          beacons: [BEACON_TOPIC_MEMBERS],
          imageUrl: members,
        },
        {
          title: 'Nesting',
          message:
            'Topics can have an infinite number of subtopics. You can structure each topic any way you wish.',
          beacons: [BEACON_TOPIC_SIDEBAR],
          imageUrl: nesting,
        },
        {
          title: 'Customize',
          message: isEditModalShown
            ? 'This is the edit topic popup. Here you can edit the topic, such as its name, details and where it is located.'
            : `For members that have permission to edit the topic, all of the topic’s settings live in ‘${TOPIC_SETTING_MENU_TITLE}’. Here, you can customize name, location, and set topic permissions.`,
          beacons: isEditModalShown
            ? [BEACON_TOPIC_EDIT_MODAL]
            : [BEACON_TOPIC_OVERFLOW_MENU, BEACON_TOPIC_EDIT],
          imageUrl: customize,
        },
        {
          title: 'Personalize',
          message:
            'Picking a descriptive topic name and details will help teams orient. Top it off with a personalized banner image.',
          beacons: [BEACON_TOPIC_OVERFLOW_MENU, BEACON_TOPIC_BANNER],
          imageUrl: personalize,
        },
        {
          title: 'Get organizing!',
          message:
            'Topics keep everything organized, but it is up to you and your team to tag posts properly. We’ll do the rest!',
          imageUrl: end,
        },
      ]}
    />
  );
};

export default TopicTutorial;
